module.exports = __webpack_public_path__ + "static/app-store-20dca34792f20af9fcb1fcecb0381aeb.svg";